import { render, staticRenderFns } from "./personal.mpx?vue&type=template&id=213f97e4&scoped=true&page=true"
import script from "./personal.mpx?vue&type=script&lang=js&page=true"
export * from "./personal.mpx?vue&type=script&lang=js&page=true"
import style0 from "./personal.mpx?vue&type=style&index=0&id=213f97e4&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22mc5106ea0%22%7D&page=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213f97e4",
  null
  
)

export default component.exports